import ErrorLogger from '@/error-logger'
window.errorLogger = new ErrorLogger()
